import React, { useState } from "react";
import "./verifyPhone.scss";
import Button from "@material-ui/core/Button";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { Card } from "@mui/material";
import MTextField from "../../components/MTextField";
import { useLocation, useNavigate } from "react-router";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import { PATH } from "../../constants/appConstants";

export default function VerifyPhone(props) {
  const dispatch = useDispatch();
  const appLocation = useLocation();
  const navigate = useNavigate();
  const [loadingApi, setLoadingApi] = useState(false);

  const [verificationInProgress, setVerificationInProgress] = useState(false);

  const [otp, setOtp] = useState("");

  React.useEffect(() => {
    // Define the 'otpless' function
    // window.otpless = (otplessUser) => {
    //     // Retrieve the user's details after successful login
    //     const waName = otplessUser.waName;
    //     const waNumber = otplessUser.waNumber;
    //     console.log(waName);
    //     console.log(waNumber);
    // };
  }, []);

  const handleChange = (event) => {
    setOtp(event.target.value);
  };

  const reSendOTP = () => {
    AjaxHelper.postApi(navigate, Endpoint.RESEND_OTP, {
      userCode: appLocation.state.userCode,
    })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("OTP sent successfully."));
        } else {
          dispatch(errorSnackbar("Unable to send otp."));
        }
      })
      .catch((err) => {
        dispatch(errorSnackbar("Unable to send otp."));
      });
  };

  const verifyOTP = () => {
    if (!isFieldEmpty(otp)) {
      setVerificationInProgress(true);
      setLoadingApi(true);
      AjaxHelper.postApi(navigate, Endpoint.VERIFY_OTP, {
        userCode: appLocation.state.userCode,
        otp,
      })
        .then((response) => {
          setVerificationInProgress(false);
          setLoadingApi(false);
          if (response.data.status === Status.API_SUCCESS) {
            accountVerifiedStatusDialog(true);
          } else {
            accountVerifiedStatusDialog(false);
          }
        })
        .catch((err) => {
          setVerificationInProgress(false);
          setLoadingApi(false);
          accountVerifiedStatusDialog(false);
        });
    } else {
      dispatch(
        setResponsiveDialog(true, "Error", "Please enter OTP to verify", "OK")
      );
    }
  };

  const accountVerifiedStatusDialog = (status) => {
    if (status) {
      dispatch(
        setResponsiveDialog(
          true,
          "Success",
          "Your phone number has been verified.",
          "OK",
          "",
          () => {
            navigate(PATH.LOGIN_SCREEN, { replace: true });
          }
        )
      );
    } else {
      dispatch(
        setResponsiveDialog(
          true,
          "Error",
          "Unable to verify the account's phone number.",
          "OK"
        )
      );
    }
  };

  return (
    <div className="component-register d-flex justify-content-start flex-column">
      <div className="brand-bg-inverse-color mb-3 col-12">
        <div className="container">
          <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
            <Link to={"/"} className="navbar-brand">
              <img
                src={require("../../assets/logo.png")}
                alt=""
                width={"140px"}
              />
            </Link>
          </nav>
        </div>
      </div>
      <div className="inner-div">
        <Card variant={"outlined"} className="register-card my-5 col-md-8">
          <div className="card-header">Verify phone number</div>
          <div className="card-body">
            <div className="form">
              <MTextField
                id={"email_otp"}
                name={"email_otp"}
                className="col-12"
                required={true}
                label={`OTP for ${appLocation.state.userCode}`}
                value={otp}
                onChange={handleChange}
                disabled={false}
                error={false}
                placeholder={"Enter OTP sent to your phone number."}
                helperText={
                  "OTP has been sent to your phone number " +
                  appLocation.state.mobile
                }
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    verifyOTP();
                  }
                }}
              />
            </div>
          </div>
          <div className="card-footer">
            <Button
              variant="contained"
              color="primary"
              className={"button2"}
              onClick={() => {
                reSendOTP();
              }}
            >
              Resend OTP
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={"button"}
              disabled={verificationInProgress}
              onClick={() => {
                verifyOTP();
              }}
            >
              Submit
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
